export default __webpack_public_path__ + "static/media/July2013.923fb171.png";